import ModuleWrapper from 'shared-lib/containers/Module';

const Schedules = () => import (/* webpackChunkName: "schedules" */ '@/views/schedules/Schedules');

const meta = (data = {}) => ({
    auth: true,
    privilegeModule: 'schedules',
    customGuard: (store) => store?.getters?.config?.feature?.scheduler?.enabled,
    ...data,
});

export default [{
    path: 'schedules',
    component: ModuleWrapper,
    meta: meta({
        title: 'Scheduled actions',
    }),
    children: [
        {
            path: '',
            name: 'Scheduled actions',
            component: Schedules,
            props: true,
            meta: meta({
                permission: 'read',
            }),
        },
    ],
}];


